import { TransitionSpecs } from '@react-navigation/stack';
import { DefaultTheme } from '@react-navigation/native';

// Theme for ReactNavigation

const MyNavigationTheme = {
  ...DefaultTheme,
  colors: DefaultTheme ? {
    ...DefaultTheme.colors,
    background: 'transparent',
  } : {},
};

// define the transition of the cards, so they move out of the way 100%,
// otherwise they would remain visible, since the cards are transparent

const TransitionScreen = {
  gestureDirection: 'horizontal',
  transitionSpec: {
    open: TransitionSpecs.TransitionIOSSpec,
    close: TransitionSpecs.TransitionIOSSpec,
  },
  cardStyleInterpolator: ({ current, next, layouts }) => ({
    cardStyle: {
      transform: [
        {
          translateX: current.progress.interpolate({
            inputRange: [0, 1],
            outputRange: [layouts.screen.width, 0],
          }),
        },
        {
          translateX: next
            ? next.progress.interpolate({
              inputRange: [0, 1],
              outputRange: [0, -layouts.screen.width],
            })
            : 1,
        },
      ],
    },
    overlayStyle: {
      opacity: current.progress.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 0.5],
      }),
    },
  }),
};

export { TransitionScreen, MyNavigationTheme };
